import React, { Component } from "react";
import { CommandBarButton } from "office-ui-fabric-react/lib/Button";
import { flatten } from "../../../utils";

import ExcelFile from "../../../export/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "../../../export/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "../../../export/ExcelPlugin/elements/ExcelColumn";

class OrdersExelExport extends Component {
  render() {
    return (
      <ExcelFile
        element={
          <CommandBarButton
            styles={{ root: { padding: "10px" } }}
            disabled={this.props.items.length === 0}
            iconProps={{ iconName: "ExcelLogo" }}
            title="Selected orders report"
            text="Orders"
          />
        }
      >
        <ExcelSheet data={this.props.items && this.props.items.map(item => flatten(item))} name="Orders">
          <ExcelColumn label="Date" value="pickupDate" />
          <ExcelColumn label="Truck" value="shipmentByShipmentId.carrierByCarrierId.trailer" />
          <ExcelColumn label="Trailer" value="shipmentByShipmentId.carrierByCarrierId.trailer" />
          <ExcelColumn label="Seller" value="relationBySellerId.name" />
          <ExcelColumn label="Buyer" value="relationByBuyerId.name" />
          <ExcelColumn label="Packing code" value="packingCode" />
          <ExcelColumn label="Boxes" value="boxes" />
          <ExcelColumn label="Full boxes" value="boxesControle" />
          <ExcelColumn label="Weight" value="brutto" />
          <ExcelColumn label="Chargeable weight" value="chargableWeight" />
          <ExcelColumn label="AirWayBill" value="awb" />
          <ExcelColumn label="House aiwraybill" value="hawb" />
          <ExcelColumn label="Flight" value="flight" />
          <ExcelColumn label="Cargo type" value="cargoTypeByCargoTypeId.type" />
          <ExcelColumn label="Origin" value="countryByCountryId.name" />
          <ExcelColumn label="Packing type" value="packingTypeByPackingId.type" />
          <ExcelColumn label="Pallets" value="amountPallets" />
          <ExcelColumn label="About" value="abount" />
        </ExcelSheet>
      </ExcelFile>
    );
  }
}

export default OrdersExelExport;



// WEBPACK FOOTER //
// ./src/views/Orders/Table/_OrdersExelExport.js